const skills = [
    'python', 
    'docker', 
    'fastapi', 
    'flask', 
    'githubactions', 
    'postman', 
    'aws', 
    'git', 
    'github', 
    'opencv', 
    'tensorflow', 
    'c', 
    'java', 
    'react', 
    'nodejs',
    'mongodb', 
    'html', 
    'css', 
    'javascript', 
    'terraform', 
    'bootstrap', 
    'arduino', 
    'linux',
];

export default skills;